import { render, staticRenderFns } from "./Session.vue?vue&type=template&id=0a0b4ff1"
import script from "./Session.vue?vue&type=script&lang=js"
export * from "./Session.vue?vue&type=script&lang=js"
import style0 from "./Session.vue?vue&type=style&index=0&id=0a0b4ff1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports